export default __webpack_public_path__ + "static/media/brake_abs.55ca4442.svg";